import { create } from 'zustand';
import { OnboardingData, FunnelData, BrandData } from '../types/index';

const initialBrandData: BrandData = {
  name: '',
  context: '',
};

type OnboardingStore = {
  data: OnboardingData;
  setStep: (step: number) => void;
  nextStep: () => void;
  previousStep: () => void;
  addFunnel: (funnel: FunnelData) => void;
  removeFunnel: (funnelId: string) => void;
  setProductLandingLink: (productId: string, websiteId: string) => void;
  updateBrandData: (data: Partial<BrandData>) => void;
  reset: () => void;
};

export const useOnboardingStore = create<OnboardingStore>((set) => ({
  data: {
    step: 1,
    selectedFunnels: [],
    productLandingLinks: {},
    brandData: initialBrandData,
  },
  setStep: (step) => set((state) => ({ data: { ...state.data, step } })),
  nextStep: () => set((state) => ({ data: { ...state.data, step: Math.min(state.data.step + 1, 2) } })),
  previousStep: () => set((state) => ({ data: { ...state.data, step: Math.max(state.data.step - 1, 1) } })),
  addFunnel: (funnel) => 
    set((state) => ({ 
      data: { 
        ...state.data, 
        selectedFunnels: [...state.data.selectedFunnels, funnel] 
      } 
    })),
  removeFunnel: (funnelId) => 
    set((state) => ({ 
      data: { 
        ...state.data, 
        selectedFunnels: state.data.selectedFunnels.filter(f => f.id !== funnelId) 
      } 
    })),
  setProductLandingLink: (productId, websiteId) =>
    set((state) => ({
      data: {
        ...state.data,
        productLandingLinks: {
          ...state.data.productLandingLinks,
          [productId]: websiteId,
        },
      },
    })),
  updateBrandData: (brandData) => 
    set((state) => ({ 
      data: { 
        ...state.data, 
        brandData: { ...state.data.brandData, ...brandData } 
      } 
    })),
  reset: () => set({
    data: {
      step: 1,
      selectedFunnels: [],
      productLandingLinks: {},
      brandData: initialBrandData,
    }
  }),
}));
